// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum VkmStatus {
    VkmAfgerekend = 'vkmAfgerekend',
    VkmGepland = 'vkmGepland',
}
